module.exports = require("apollo3-cache-persist");